<template>
  <div>
    <nav-bar/>
    <div class="sidebar col-2 bg-darkgrey navbar-inverse side-box-shadow">
      <ul class="nav flex-column">
        <li v-if="!$route.query.archive" class="nav-item">
          <a class="nav-link navbar-text pull-left" href="#" @click.prevent="openModification()">{{$t('OrderInfo.sidebar.modification')}}</a>
        </li>
        <li v-if="!$route.query.archive" class="nav-item">
          <a class="nav-link navbar-text pull-left" href="#" @click.prevent="openDispatch()">{{$t('OrderInfo.sidebar.dispatch')}}</a>
        </li>
        <li class="nav-item">
          <a class="nav-link navbar-text pull-left" href="#" @click.prevent="openInspection()">{{$t('OrderInfo.sidebar.inspection')}}</a>
        </li>
        <li class="nav-item">
          <a class="nav-link navbar-text pull-left" :href="originalOrder.invoice" target="_blank">{{$t('OrderInfo.sidebar.purchase')}}</a>
        </li>
        <li v-if="!$route.query.archive" class="nav-item">
          <a class="nav-link navbar-text pull-left" href="#" @click.prevent="openSend()">{{$t('OrderInfo.sidebar.send')}}</a>
        </li>
        <!-- <li class="nav-item">
          <a class="nav-link navbar-text pull-left" href="#" @click.prevent="chat = true">{{$t('OrderInfo.sidebar.chat')}}</a>
          <span v-if="notes.length > 0" class="pull-right badge badge-default">{{ notes.length }}</span>
        </li> -->
        <li v-if="!$route.query.archive" class="nav-item">
          <span class="navbar-text pull-left pl-3">{{$t('OrderInfo.sidebar.statusChange')}}</span>
          <select class="form-control" :value="originalOrder.status" @change="changeStatus($event.target.value)">
            <option value="Dispatch">{{$t('Search.status.dispatch')}}</option>
            <option value="Processing">{{$t('Search.status.processing')}}</option>
            <option value="Pick">{{$t('Search.status.pick')}}</option>
            <option value="Attente">{{$t('Search.status.waiting')}}</option>
            <option value="Transit">{{$t('Search.status.transit')}}</option>
            <option value="Drop">{{$t('Search.status.drop')}}</option>
            <option value="Cancel">{{$t('Search.status.canceled')}}</option>
            <!-- <option v-if="$store.state.userInfo && !$store.state.userInfo.isSageOne" value="Terminée">{{$t('Search.status.finished')}}</option>-->
            <option value="Terminée">{{$t('Search.status.finished')}}</option>
            <option value="Transférée">{{$t('Search.status.transfered')}}</option>
            <option value="Reject">{{$t('Search.status.rejected')}}</option>
           </select>
         </li>
         <button v-if="!$route.query.archive" id="chat" class="btn btn-kne-orange col-12 mt-3 text-left" @click="openNote()">
           {{$t('OrderInfo.sidebar.chat')}}
           <span v-if="notes.length > 0" class="pull-right badge btn-badge badge-default">{{ notes.length }}</span>
         </button>
       </ul>
     </div>

     <div class="col-10 offset-2 pt-3 px-0">

       <div class="col-12 mb-3">
         <div id="location" class="card">
           <v-map :zoom=12 :center="[order.latitude, order.longitude]">
             <v-tilelayer url="http://{s}.tile.osm.org/{z}/{x}/{y}.png"/>
             <v-marker :lat-lng="[order.latitude, order.longitude]"></v-marker>
           </v-map>
         </div>
       </div>

       <transition name="fade">
         <div  v-if='history.length > 0' class="col-12 mb-3">
           <div class="card">
             <div class="card-header">
               <h3 class="my-3">{{$t('OrderInfo.delivery.title')}}</h3>
             </div>
             <div class="table-responsive">
               <table class="table table-hover font-grey mb-0">
                 <thead class="bg-darkgrey">
                   <tr>
                     <th>{{$t('OrderInfo.delivery.order')}}</th>
                     <th>{{$t('OrderInfo.delivery.driver')}}</th>
                     <th>{{$t('OrderInfo.delivery.date')}}</th>
                     <th>{{$t('OrderInfo.delivery.pickup')}}</th>
                     <th>{{$t('OrderInfo.delivery.delivery')}}</th>
                     <th>{{$t('OrderInfo.delivery.pickTime')}}</th>
                     <th>{{$t('OrderInfo.delivery.dropTime')}}</th>
                     <th>{{$t('OrderInfo.delivery.reference')}}</th>
                     <th>{{$t('OrderInfo.delivery.price')}}</th>
                     <th></th>
                   </tr>
                 </thead>
                 <transition-group name="fade" tag="tbody">
                   <tr v-for="(entry, key, index) in history" :key="entry['.key']">
                     <td>{{ entry['.key'] }}</td>
                     <td>{{ entry.chauffeurName }}</td>
                     <td>{{ entry.dateDispatch }}</td>
                     <td>{{ entry.transmitterName }}</td>
                     <td>{{ entry.receiverName }}</td>
                     <td v-if="entry.pickDate">{{ getDate(entry.pickDate)}}</td>
                     <td v-else></td>
                     <td v-if="entry.dropDate">{{ getDate(entry.dropDate)}}</td>
                     <td v-else></td>
                     <td>{{ entry.numRef }}</td>
                     <td v-if="entry.prix">{{ ((parseFloat(entry.prix)).toLocaleString('fr-CA', { style: 'currency', currency: 'CAD' }))}}</td>
                     <td v-else></td>
                     <td>
                       <input v-if="!$route.query.archive" type="button" class="btn btn-kne-orange pull-right" @click="openModificationDelivery(entry)" :value="$t('OrderInfo.delivery.modify')">
                     </td>
                   </tr>
                 </transition-group>
               </table>
             </div>
           </div>
         </div>
       </transition>

       <transition name="fade">
         <modal v-if="preview" closableBackdrop closable @close-request="close()">
           <div class="text-center">
             <img :src="previewImgUrl" class="img-fluid">
             <p>{{ previewId }}</p>
             <p>{{ previewName }}</p>
             <p>{{ previewComment }}</p>
           </div>
         </modal>
         <modal v-if="chat || modify || modifyDelivery || dispatch || inspection || send" @close-request="close()" closable>

           <div v-if="modify">
             <h3 class="text-center">Modification</h3>

             <div class="tab-content row">
              <div class="mt-3 col-4 pr-0" id="pickup" role="">
                <h4 class="mx-3 kne-title">{{$t('OrderInfo.modal.pickup.title')}}</h4>
                <regular-datalist
                :value="datalist.pickup"
                @input="setAndSearch($event, 'pickup')"
                :originalList="$store.state.allContacts"
                :secondList="addressbook"
                :placeholder="$t('AddressBook.title')" class="col-12 form-group"/>
                <regular-input
                :value="order.transmitterName"
                @input="order.transmitterName = $event"
                type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.name') + '*'" class="col-12 form-group"/>
                <regular-input
                :value="order.transmitterAddress"
                @input="order.transmitterAddress = $event"
                type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.address') + '*'" class="col-12 form-group"/>
                <regular-input
                :value="order.transmitterCity"
                @input="order.transmitterCity = $event"
                type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.city')" class="col-12 form-group"/>
                <regular-input
                :value="order.transmitterPostcode"
                @input="order.transmitterPostcode = $event"
                type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.postal_code')" class="col-12 form-group"/>
                <regular-input
                :value="order.transmitterProvince"
                @input="order.transmitterProvince = $event"
                type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.province')" class="col-12 form-group"/>
                <regular-input
                :value="order.transmitterCountry"
                @input="order.transmitterCountry = $event"
                type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.country')" class="col-12 form-group"/>
                <regular-input
                :value="order.transmitterEmail"
                @input="order.transmitterEmail = $event"
                type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.email')" class="col-12 form-group"/>
                <regular-input
                :value="order.transmitterPhone"
                @input="order.transmitterPhone = $event"
                type="tel" :placeholder="$t('OrderPending.pickupDeliveryTab.phone')" class="col-12 form-group"/>
                <regular-input
                :value="order.transmitterFax"
                @input="order.transmitterFax = $event"
                type="tel" :placeholder="$t('OrderPending.pickupDeliveryTab.fax')" class="col-12 form-group"/>
                <regular-input
                :value="order.transmitterContact"
                @input="order.transmitterContact = $event"
                type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.contact')" class="col-12 form-group"/>
              </div>

              <div class="mt-3 col-4 px-0" id="delivery">
                <h4 class="mx-3 kne-title">{{$t('OrderInfo.modal.delivery.title')}}</h4>
                <regular-datalist
                :value="datalist.delivery"
                @input="setAndSearch($event, 'delivery')"
                :originalList="$store.state.allContacts"
                :secondList="addressbook"
                :placeholder="$t('AddressBook.title')" class="col-12 form-group"/>
                <regular-input
                :value="order.receiverName"
                @input="order.receiverName = $event"
                type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.name') + '*'" class="col-12 form-group"/>
                <regular-input
                :value="order.receiverAddress"
                @input="order.receiverAddress = $event"
                type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.address') + '*'" class="col-12 form-group"/>
                <regular-input
                :value="order.receiverCity"
                @input="order.receiverCity = $event"
                type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.city')" class="col-12 form-group"/>
                <regular-input
                :value="order.receiverPostcode"
                @input="order.receiverPostcode = $event"
                type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.postal_code')" class="col-12 form-group"/>
                <regular-input
                :value="order.receiverProvince"
                @input="order.receiverProvince = $event"
                type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.province')" class="col-12 form-group"/>
                <regular-input
                :value="order.receiverCountry"
                @input="order.receiverCountry = $event"
                type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.country')" class="col-12 form-group"/>
                <regular-input
                :value="order.receiverEmail"
                @input="order.receiverEmail = $event"
                type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.email')" class="col-12 form-group"/>
                <regular-input
                :value="order.receiverPhone"
                @input="order.receiverPhone = $event"
                type="tel" :placeholder="$t('OrderPending.pickupDeliveryTab.phone')" class="col-12 form-group"/>
                <regular-input
                :value="order.receiverFax"
                @input="order.receiverFax = $event"
                type="tel" :placeholder="$t('OrderPending.pickupDeliveryTab.fax')" class="col-12 form-group"/>
                <regular-input
                :value="order.receiverContact"
                @input="order.receiverContact = $event"
                type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.contact')" class="col-12 form-group"/>
              </div>

              <div class="mt-3 col-4 pl-0" id="billing">
                <h4 class="mx-3 kne-title">{{$t('OrderInfo.modal.billing.title')}}</h4>
                <regular-datalist
                :value="datalist.billing"
                @input="setAndSearch($event, 'billing')"
                :originalList="$store.state.allContacts"
                :secondList="addressbook"
                :placeholder="$t('AddressBook.title')" class="col-12 form-group"/>
                <regular-input
                :value="order.payerName"
                @input="order.payerName = $event"
                type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.name') + '*'" class="col-12 form-group"/>
                <regular-input
                :value="order.payerAddress"
                @input="order.payerAddress = $event"
                type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.address') + '*'" class="col-12 form-group"/>
                <regular-input
                :value="order.payerCity"
                @input="order.payerCity = $event"
                type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.city')" class="col-12 form-group"/>
                <regular-input
                :value="order.payerPostcode"
                @input="order.payerPostcode = $event"
                type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.postal_code')" class="col-12 form-group"/>
                <regular-input
                :value="order.payerProvince"
                @input="order.payerProvince = $event"
                type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.province')" class="col-12 form-group"/>
                <regular-input
                :value="order.payerCountry"
                @input="order.payerCountry = $event"
                type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.country')" class="col-12 form-group"/>
                <regular-input
                :value="order.payerEmail"
                @input="order.payerEmail = $event"
                type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.email')" class="col-12 form-group"/>
                <regular-input
                :value="order.payerPhone"
                @input="order.payerPhone = $event"
                type="tel" :placeholder="$t('OrderPending.pickupDeliveryTab.phone')" class="col-12 form-group"/>
                <regular-input
                :value="order.payerFax"
                @input="order.payerFax = $event"
                type="tel" :placeholder="$t('OrderPending.pickupDeliveryTab.fax')" class="col-12 form-group"/>
                <regular-input
                :value="order.payerContact"
                @input="order.payerContact = $event"
                type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.contact')" class="col-12 form-group"/>
              </div>
            </div>
            <h4 class="mx-3 kne-title">Information</h4>
            <div class="container-fluid">
              <div class="row pt-4">
                <regular-input
                :value="order.numRef"
                @input="order.numRef = $event"
                type="text" :placeholder="$t('OrderInfo.modal.reference')" class="col-12 col-sm-6 form-group"/>
                <regular-input
                :value="order.price"
                @input="order.price = $event"
                type="number" :placeholder="$t('OrderInfo.modal.price')" class="col-12 col-sm-6 form-group"/>
                <regular-input
                :value="order.vin"
                @input="order.vin = $event"
                type="text" :placeholder="$t('OrderInfo.modal.VIN')" class="col-12 col-sm-6 form-group"/>
                <regular-input
                :value="order.year"
                @input="order.year = $event"
                type="number" :placeholder="$t('OrderInfo.modal.year')" class="col-12 col-sm-6 form-group"/>
                <regular-input
                :value="order.make"
                @input="order.make = $event"
                type="text" :placeholder="$t('OrderInfo.modal.make')" class="col-12 col-sm-6 form-group"/>
                <regular-input
                :value="order.model"
                @input="order.model = $event"
                type="text" :placeholder="$t('OrderInfo.modal.model')" class="col-12 col-sm-6 form-group"/>
                <regular-textarea
                :value="order.comment"
                @input="order.comment = $event"
                :placeholder="$t('OrderInfo.modal.comment')" class="col-12 form-group" rows="6"/>
              </div>
            </div>
             <div class="">
               <regular-input
                 :value="order.datePromis"
                 @input="order.datePromis =  $event"
                 type="date" :placeholder="$t('OrderPending.orderTab.datePromis')" class="col-12 form-group"
               />
             </div>
            <div class="col-12">
              <button class="btn btn-kne-orange w-100 form-group" :disabled="!formCompleted" @click="modifyOrder()">{{$t('OrderInfo.modal.modify')}}</button>
            </div>
            <div class="container-fluid">
              <div class="row">
                <regular-select
                :value="taxes"
                @change="taxes = $event"
                :placeholder="$t('OrderInfo.modal.tax')" class="col-12 col-sm-6 form-group">
                    <option v-for="province in $store.state.provinces" :value="province">{{province}}</option>
                </regular-select>
                <regular-input
                :value="order.billingDate"
                @input="order.billingDate = formatDate($event)"
                type="date" :placeholder="$t('OrderInfo.modal.date')" class="col-12 col-sm-6 form-group"/>
              </div>
            </div>
            <div class="col-12">
              <div class="row">
                <regular-textarea
                  :value="taxesComment"
                  @input="taxesComment = $event"
                  :placeholder="$t('OrderInfo.modal.taxesComment')" class="col-12 form-group" rows="6"/>
              </div>
            </div>
            <div class="col-12">
              <a target="_blank" :href="'https://mysageone.ca.sageone.com/oauth2/auth?response_type=code&client_id=3ff1477e6ec457b7df62&redirect_uri=https://systems.keepneye.com/api4/SageoneToken&scope=full_access&transpuid=' + companyUID + '&commandid=' + $route.query.orderId ">
                <button :disabled="taxes === '' || !order.sageID || order.price === '' || order.billingDate === ''" class="btn btn-kne-orange w-100" @click="modifyOrder()">{{$t('OrderInfo.modal.billing.title')}}</button>
              </a>
            </div>
          </div>

           <div v-if="inspection">
             <h3 class="kne-title mx-3">Inspection</h3>
             <div class="col-12">
               <div class="row">
                 <regular-select
                 :value="inspectionOrder.key"
                 @change="inspectionOrder.key = $event"
                 :placeholder="$t('OrderInfo.modal.choose')" class="col-12 col-sm-6 form-group">
                   <option v-for="order in history">{{order['.key']}}</option>
                 </regular-select>
                 <div class="col-12 col-sm-6">
                   <button class="btn btn-kne-orange w-100 form-group" :disabled="!orderChosen" @click="generate()">{{$t('OrderInfo.modal.generate')}}</button>
                 </div>
                 <!-- <div class="ml-auto col-sm-6">
                   <button class="btn btn-kne-orange w-100 form-group" :disabled="!orderChosen" @click="generate()">{{$t('OrderInfo.modal.merge')}}</button>
                 </div> -->
               </div>
             </div>
             <div class="col-12">
             <div class="row">
                 <regular-input
                 :value="inspectionOrder.email"
                 @input="inspectionOrder.email = $event"
                 type="text" :placeholder="$t('OrderInfo.modal.email')" class="col-12 col-sm-6"/>
                 <div class="col-12 col-sm-6">
                   <button class="btn btn-kne-orange w-100 form-group" :disabled="!emailEntered" @click="sendBolTo()">{{$t('OrderInfo.modal.BOL')}}</button>
                 </div>
                 <div class="ml-auto col-sm-6">
                   <button class="btn btn-kne-orange w-100 form-group" @click="mergeBody()">{{$t('OrderInfo.modal.merge')}}</button>
                 </div>
               </div>
             </div>
           </div>

           <div v-if="dispatch || send">
             <h3 v-if="dispatch" class="text-center">{{$t('OrderInfo.sidebar.dispatch')}}</h3>
             <h3 v-else class="text-center">{{$t('OrderInfo.sidebar.send')}}</h3>
             <div class=" pt-4">
               <!-- <regular-select
               v-if="dispatch"
               :value="dispatchOrder.chauffeur"
               @change="dispatchOrder.chauffeur = $event"
               :placeholder="$t('OrderInfo.modal.driver')" class="col-12 form-group">
                 <option v-for="driver in listOrdered" :value="driver['.key']">{{ driver['.value'] }}</option>
               </regular-select> -->
              <regular-datalist-driver
              v-if="dispatch"
              :value="dispatchOrder.chauffeurName"
              @input="dispatchOrder.chauffeurName = $event.value; dispatchOrder.chauffeur = $event.key"
              :secondList="listOrdered"
              :placeholder="$t('OrderInfo.modal.driver')" class="col-12 form-group"/>
              <regular-select
              v-else
              :value="sendOrder.carrier"
              @change="sendOrder.carrier = $event"
              :placeholder="$t('OrderInfo.modal.carrier')" class="col-12 form-group">
                <option v-for="c in carriersOrdered" :value="c['.key']">{{ c['.value'] }}</option>
              </regular-select>
            </div>

            <div class="tab-content row">
              <div class="mt-3 col-6 pr-0" id="pickup">
                <h4 class="mx-3 kne-title">{{$t('OrderInfo.modal.pickup.title')}}</h4>
                <regular-datalist
                :value="datalist.pickup"
                @input="setAndSearch($event, 'pickup')"
                :originalList="$store.state.allContacts"
                :secondList="addressbook"
                :placeholder="$t('AddressBook.title')" class="col-12 form-group"/>
                <regular-input
                :value="order.transmitterName"
                @input="order.transmitterName = $event"
                type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.name') + '*'" class="col-12 form-group"/>
                <regular-input
                :value="order.transmitterAddress"
                @input="order.transmitterAddress = $event"
                type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.address') + '*'" class="col-12 form-group"/>
                <regular-input
                :value="order.transmitterCity"
                @input="order.transmitterCity = $event"
                type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.city')" class="col-12 form-group"/>
                <regular-input
                :value="order.transmitterPostcode"
                @input="order.transmitterPostcode = $event"
                type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.postal_code')" class="col-12 form-group"/>
                <regular-input
                :value="order.transmitterProvince"
                @input="order.transmitterProvince = $event"
                type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.province')" class="col-12 form-group"/>
                <regular-input
                :value="order.transmitterCountry"
                @input="order.transmitterCountry = $event"
                type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.country')" class="col-12 form-group"/>
                <regular-input
                :value="order.transmitterEmail"
                @input="order.transmitterEmail = $event"
                type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.email')" class="col-12 form-group"/>
                <regular-input
                :value="order.transmitterPhone"
                @input="order.transmitterPhone = $event"
                type="tel" :placeholder="$t('OrderPending.pickupDeliveryTab.phone')" class="col-12 form-group"/>
                <regular-input
                :value="order.transmitterFax"
                @input="order.transmitterFax = $event"
                type="tel" :placeholder="$t('OrderPending.pickupDeliveryTab.fax')" class="col-12 form-group"/>
                <regular-input
                :value="order.transmitterContact"
                @input="order.transmitterContact = $event"
                type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.contact')" class="col-12 form-group"/>
              </div>

              <div class="mt-3 col-6 pl-0" id="delivery">
                <h4 class="mx-3 kne-title">{{$t('OrderInfo.modal.delivery.title')}}</h4>
                <regular-datalist
                :value="datalist.delivery"
                @input="setAndSearch($event, 'delivery')"
                :originalList="$store.state.allContacts"
                :secondList="addressbook"
                :placeholder="$t('AddressBook.title')" class="col-12 form-group"/>
                <regular-input
                :value="order.receiverName"
                @input="order.receiverName = $event"
                type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.name') + '*'" class="col-12 form-group"/>
                <regular-input
                :value="order.receiverAddress"
                @input="order.receiverAddress = $event"
                type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.address') + '*'" class="col-12 form-group"/>
                <regular-input
                :value="order.receiverCity"
                @input="order.receiverCity = $event"
                type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.city')" class="col-12 form-group"/>
                <regular-input
                :value="order.receiverPostcode"
                @input="order.receiverPostcode = $event"
                type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.postal_code')" class="col-12 form-group"/>
                <regular-input
                :value="order.receiverProvince"
                @input="order.receiverProvince = $event"
                type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.province')" class="col-12 form-group"/>
                <regular-input
                :value="order.receiverCountry"
                @input="order.receiverCountry = $event"
                type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.country')" class="col-12 form-group"/>
                <regular-input
                :value="order.receiverEmail"
                @input="order.receiverEmail = $event"
                type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.email')" class="col-12 form-group"/>
                <regular-input
                :value="order.receiverPhone"
                @input="order.receiverPhone = $event"
                type="tel" :placeholder="$t('OrderPending.pickupDeliveryTab.phone')" class="col-12 form-group"/>
                <regular-input
                :value="order.receiverFax"
                @input="order.receiverFax = $event"
                type="tel" :placeholder="$t('OrderPending.pickupDeliveryTab.fax')" class="col-12 form-group"/>
                <regular-input
                :value="order.receiverContact"
                @input="order.receiverContact = $event"
                type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.contact')" class="col-12 form-group"/>
              </div>
            </div>
            <h4 class="mx-3 kne-title">Information</h4>
            <div class=" pt-4">
              <div class="col-12">
                <div class="row">
                  <regular-input
                  :value="order.numRef"
                  @input="order.numRef = $event"
                  type="text" :placeholder="$t('OrderInfo.modal.reference')" class="col-12 col-sm-6 form-group"/>
                  <regular-input
                  :value="order.price"
                  @input="order.price = $event"
                  type="number" :placeholder="$t('OrderInfo.modal.price')" class="col-12 col-sm-6 form-group"/>
                  <regular-textarea
                  :value="order.comment"
                  @input="order.comment = $event"
                  :placeholder="$t('OrderInfo.modal.comment')" class="col-12 form-group" rows="6"/>
                </div>
              <button v-if="dispatch" class="btn btn-kne-orange w-100" :disabled="!dispatchFormFilled" @click="dispatchAction()">{{$t('OrderInfo.modal.dispatch')}}</button>
              <button v-else class="btn btn-kne-orange w-100" :disabled="!sendFormFilled" @click="sendAction()">{{$t('OrderInfo.modal.send')}}</button>
              </div>
            </div>
          </div>

          <div v-if="chat">
            <div class="container-fluid">
            <div class="row">
            <div class="col-6">
              <h3 class="font-grey kne-title">{{$t('Dashboard.new_note_title')}}</h3>
              <regular-textarea
                :value="note.text"
                @input="note.text = $event"
                :placeholder="$t('Dashboard.new_note_message')" class="p-2" rows="4"/>
              <div class="container pb-2">
                <div class="row">
                  <regular-input
                    :value="note.name"
                    @input="note.name = $event"
                    :placeholder="$t('Dashboard.new_note_name')" class="col-12 col-md-6 pl-2 pr-1"/>
                  <div class="col-12 col-md-6 pr-2 pl-1">
                    <button class="btn btn-kne-orange w-100" :disabled="!noteFilled" @click="sendNote()">
                      {{$t('General.send')}}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-6">
              <h3 class="font-grey kne-title">{{$t('Dashboard.notes_title')}}</h3>
                <transition-group name="fade" tag="div">
                  <div v-for="n in reversedNotes" class="card-block p-3 message" data-toggle="collapse" data-parent="#accordion" :href="'#collapse' + n['.key']" aria-expanded="true" :aria-controls="'#collapse' + n['.key']" :key="n['.key']">
                    <div :id="'collapse' + n['.key']" class="collapse" role="tabpanel" aria-labelledby="headingOne">
                      <p class="text-justify">{{n.text}}</p>
                    </div>
                    <p class="header font-grey">
                      <i>{{n.name}}</i>
                      <i class="pull-right">{{ getDate(n.date)}}</i>
                    </p>
                  </div>
                </transition-group>
            </div>
            </div>
            </div>
          </div>

          <div v-if="modifyDelivery">
            <h4 class="kne-title mx-3">Modification</h4>
            <div class="col-12">
              <div class="row">
                <regular-input
                :value="order.numRef"
                @input="order.numRef = $event"
                type="text" :placeholder="$t('OrderInfo.modal.reference')" class="col-12 col-sm-6 form-group"/>
                <regular-input
                :value="order.price"
                @input="order.price = $event"
                type="number" :placeholder="$t('OrderInfo.modal.price')" class="col-12 col-sm-6 form-group"/>
                <regular-textarea
                :value="order.comment"
                @input="order.comment = $event"
                :placeholder="$t('OrderInfo.modal.comment')" class="col-12 form-group" rows="6"/>
                <div class="col-12 col-sm-6">
                  <button class="btn btn-kne-orange w-100 mb-3" @click="modifyDeliveryAction()">{{$t('OrderInfo.modal.save')}}</button>
                </div>
                <div class="col-12 col-sm-6">
                  <a :href="deliveryInvoice" target="_blank">
                    <button class="btn btn-kne-orange w-100 mb-3" @click="">{{$t('OrderInfo.modal.purchase')}}</button>
                  </a>
                </div>
                <div class="col-12 col-sm-6">
                    <button class="btn btn-kne-orange w-100" @click="resend()">{{$t('OrderInfo.modal.resend')}}</button>
                </div>
                <div class="col-12 col-sm-6">
                    <button class="btn btn-kne-orange w-100" @click="regenerate()">{{$t('OrderInfo.modal.regenerate')}}</button>
                </div>
              </div>
            </div>
          </div>

        </modal>
      </transition>
      <transition name="fade">
        <div v-if='originalOrder.isTransfered && originalOrder.idTransfer' class="col-12 my-3">
          <div class="card">
            <div class="card-header">
              <h3 class="my-3">{{$t('OrderInfo.transfered.title')}}</h3>
            </div>
            <div class="table-responsive">
              <table class="table table-hover font-grey mb-0">
                <thead class="bg-darkgrey">
                  <tr>
                    <th>{{$t('OrderInfo.transfered.carrier')}}</th>
                    <th>{{$t('OrderInfo.transfered.reference')}}</th>
                    <th>{{$t('OrderInfo.transfered.order')}}</th>
                    <th>{{$t('OrderInfo.transfered.VIN')}}</th>
                    <th>{{$t('OrderInfo.transfered.date')}}</th>
                    <th>{{$t('OrderInfo.transfered.pickup')}}</th>
                    <th>{{$t('OrderInfo.transfered.delivery')}}</th>
                    <th>{{$t('OrderInfo.transfered.status')}}</th>
                    <th v-if="originalOrder.priceTransfered">{{$t('OrderInfo.transfered.refTransfer')}}</th>
                    <th v-if="originalOrder.refTransfered">{{$t('OrderInfo.transfered.priceTransfer')}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{transfer.transpName}}</td>
                    <td>{{transfer.orderRef}}</td>
                    <td>{{transfer['.key']}}</td>
                    <td>{{transfer.vin}}</td>
                    <td>{{getDate(transfer.creationDate)}}</td>
                    <td>{{transfer.transmitterName}}</td>
                    <td>{{transfer.receiverName}}</td>
                    <td>{{transfer.status}}</td>
                    <td v-if="originalOrder.refTransfered">{{originalOrder.refTransfered}}</td>
                    <td v-if="originalOrder.priceTransfered">{{originalOrder.priceTransfered}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="card-block">
              <div class="row">
                <regular-input
                  :value="modifyTransfer.refTransfered"
                  @input="modifyTransfer.refTransfered = $event"
                  type="text" :placeholder="$t('OrderInfo.transfered.refTransfer')" class="col-12 col-sm-4"/>
                <regular-input
                  :value="modifyTransfer.priceTransfered"
                  @input="modifyTransfer.priceTransfered = $event"
                  type="number" :placeholder="$t('OrderInfo.transfered.priceTransfer')" class="col-12 col-sm-4"/>
                <div class="col-sm-4">
                  <button class="btn btn-kne-orange w-100" @click="modifyTransferAction()">{{$t('OrderInfo.transfered.confirm')}}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>

      <div id="info">

        <div class="col-12 col-lg-4 mb-3">
          <div class="card font-grey">
            <div class="card-block">
              <div class="info pt-3 pb-4">
                <p class="card-text">
                  <strong>{{$t('OrderInfo.information.status')}}</strong>
                  <span v-if="originalOrder.status === 'Dispatch'" class="pull-right">{{$t('Search.status.dispatch')}}</span>
                  <span v-if="originalOrder.status === 'Processing'" class="pull-right">{{$t('Search.status.processing')}}</span>
                  <span v-if="originalOrder.status === 'Pick'" class="pull-right">{{$t('Search.status.pick')}}</span>
                  <span v-if="originalOrder.status === 'Attente'" class="pull-right">{{$t('Search.status.waiting')}}</span>
                  <span v-if="originalOrder.status === 'Transit'" class="pull-right">{{$t('Search.status.transit')}}</span>
                  <span v-if="originalOrder.status === 'Drop'" class="pull-right">{{$t('Search.status.drop')}}</span>
                  <span v-if="originalOrder.status === 'Cancel'" class="pull-right">{{$t('Search.status.canceled')}}</span>
                  <span v-if="originalOrder.status === 'Terminée'" class="pull-right">{{$t('Search.status.finished')}}</span>
                  <span v-if="originalOrder.status === 'Transférée'" class="pull-right">{{$t('Search.status.transfered')}}</span>
                  <span v-if="originalOrder.status === 'Reject'" class="pull-right">{{$t('Search.status.rejected')}}</span>
                </p>
              </div>
              <div class="info pt-3 pb-4">
                <p class="card-text"><strong>{{$t('OrderInfo.information.order')}}</strong><span class="pull-right">{{ originalOrder['.key'] }}</span></p>
              </div>
              <div class="info pt-3 pb-4">
                <p class="card-text"><strong>{{$t('OrderInfo.information.creationDate')}}</strong><span class="pull-right">{{ getDate(originalOrder.creationDate) }}</span></p>
              </div>
              <div class="info pt-3 pb-4">
                <p class="card-text"><strong>{{$t('OrderInfo.information.VIN')}}</strong><span class="pull-right">{{ originalOrder.vin }}</span></p>
              </div>
              <div class="info pt-3 pb-4">
                <p class="card-text"><strong>{{$t('OrderInfo.information.year')}}</strong><span class="pull-right">{{ originalOrder.year }}</span></p>
              </div>
              <div class="info pt-3 pb-4">
                <p class="card-text"><strong>{{$t('OrderInfo.information.make')}}</strong><span class="pull-right">{{ originalOrder.make }}</span></p>
              </div>
              <div class="info pt-3 pb-4">
                <p class="card-text"><strong>{{$t('OrderInfo.information.model')}}</strong><span class="pull-right">{{ originalOrder.model }}</span></p>
              </div>
              <div class="info pt-3 pb-4">
                <p class="card-text"><strong>{{$t('OrderInfo.information.pickup')}}</strong><span class="pull-right">{{ originalOrder.transmitterName }}</span></p>
              </div>
              <div class="info pt-3 pb-4">
                <p class="card-text"><strong>{{$t('OrderInfo.information.delivery')}}</strong><span class="pull-right">{{ originalOrder.receiverName }}</span></p>
              </div>
              <div class="info pt-3 pb-4">
                <p class="card-text"><strong>{{$t('OrderInfo.information.billing')}}</strong><span class="pull-right">{{ originalOrder.payerName }}</span></p>
              </div>
              <div class="info pt-3 pb-4">
                <p class="card-text"><strong>{{$t('OrderInfo.information.price')}}</strong>
                  <span v-if="originalOrder.price" class="pull-right">{{ ((parseFloat(originalOrder.price)).toLocaleString('fr-CA', { style: 'currency', currency: 'CAD' })) }}</span>
                  <span v-else></span>
                </p>
              </div>
              <div class="info pt-3 pb-4">
                <p class="card-text"><strong>{{$t('OrderInfo.information.reference')}}</strong><span class="pull-right">{{ originalOrder.numRef }}</span></p>
              </div>
              <div class="info pt-3 pb-4">
                <p class="card-text"><strong>{{$t('Facture')}}</strong><span class="pull-right">{{ originalOrder.billNum }}</span></p>
              </div>
              <div class="info pt-3 pb-4">
                <p class="card-text"><strong>{{$t('OrderInfo.information.comment')}}</strong><span class="pull-right">{{ originalOrder.comment }}</span></p>
              </div>
              <div class="info pt-3 pb-4">
                <p class="card-text"><strong>{{$t('OrderInfo.information.keys')}}</strong><span class="pull-right">{{ originalOrder.nbKey }}</span></p>
              </div>
              <div class="info pt-3 pb-4">
                <p class="card-text"><strong>{{$t('OrderInfo.information.trackingCode')}}</strong><span class="pull-right">{{ originalOrder.codeSecret }}</span></p>
              </div>
            </div>
          </div>
        </div>

        <div class="col-12 col-lg-8">
          <div class="card font-grey">
            <div class="card-block p-1">
              <h5 class="text-center pt-4">{{$t('OrderInfo.photos')}}</h5>
              <img v-for="photoUrl in order.photos" :src="photoUrl" class="m-1 img-fluid mini" @click="openPreview($event.target.currentSrc)">
            </div>
            <div class="card-block p-1">
              <h5 class="text-center pt-4">{{$t('OrderInfo.bodyPhotos')}}</h5>
              <img v-for="photoUrl in order.bodyPhotos" :src="photoUrl" class="m-1 img-fluid mini" @click="openPreview($event.target.currentSrc)">
            </div>
            <div class="card-block p-1">
              <h5 class="text-center pt-4">{{$t('OrderInfo.signaturePhotos')}}</h5>
              <img v-for="entry in history" :src="entry.pickSignature" class="m-1 img-fluid mini" @click="openPreview($event.target.currentSrc, entry.pickName, entry.nightPickComment, entry['.key'])">
            </div>
            <div class="card-block p-1">
              <h5 class="text-center pt-4">{{$t('OrderInfo.signatureDrop')}}</h5>
              <img v-for="entry in history" :src="entry.dropSignature" class="m-1 img-fluid mini" @click="openPreview($event.target.currentSrc, entry.dropName, entry.nightDropComment, entry['.key'])">
            </div>
            <div class="card-block p-1">
              <h5 class="text-center pt-4">{{$t('OrderInfo.dropPhotos')}}</h5>
              <div v-for="dispatch in history">
                <img v-for="entry in dispatch.dropPhotos" :src="entry" class="m-1 img-fluid mini" @click="openPreview($event.target.currentSrc)">
                <p class="text-center">
                  {{history.nightDropComment}}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import Modal from '../Modal.vue'
import regularInput from '../regularInput.vue'
import regularSelect from '../regularSelect.vue'
import regularTextarea from '../regularTextarea.vue'
import OrderActionBar from '../OrderActionBar.vue'
import regularDatalistDriver from '../regularDatalistDriver.vue'
import {db, dbArchives} from '../../firebase'

export default {
  name: 'OrderInfo',
  components: {
    Modal,
    regularInput,
    regularSelect,
    regularTextarea,
    OrderActionBar,
    regularDatalistDriver
  },
  data () {
    return {
      chat: false,
      modify: false,
      dispatch: false,
      inspection: false,
      send: false,
      modifyDelivery: false,
      preview: false,
      carrier: '',
      deliveryOrder: '',
      deliveryInvoice: '',
      deliveryChauffeur: '',
      taxes: '',
      taxesComment: '',
      modifyTransfer: {
        refTransfered: '',
        priceTransfered: ''
      },
      inspectionOrder: {
        email: '',
        key: ''
      },
      sendOrder: {
        carrier: '',
        carrierName: ''
      },
      dispatchOrder: {
        chauffeur: '',
        chauffeurName: ''
      },
      order: {
        comment: '',
        latitude: 0.001,
        longitude: 0.001,
        make: '',
        model: '',
        nbDispatch: 0,
        numRef: '',
        payer: '',
        payerAddress: '',
        datePromis: '',
        payerCity: '',
        payerContact: '',
        payerFax: '',
        payerName: '',
        payerPhone: '',
        payerEmail: '',
        payerPostcode: '',
        payerCountry: '',
        payerProvince: '',
        price: '',
        billNum: '',
        billingDate: '',
        receiver: '',
        receiverAddress: '',
        receiverCity: '',
        receiverContact: '',
        receiverFax: '',
        receiverName: '',
        receiverPhone: '',
        receiverEmail: '',
        receiverPostcode: '',
        receiverCountry: '',
        receiverProvince: '',
        status: '',
        source: '',
        transmitter: '',
        transmitterAddress: '',
        transmitterCity: '',
        transmitterContact: '',
        transmitterFax: '',
        transmitterName: '',
        transmitterPhone: '',
        transmitterEmail: '',
        transmitterPostcode: '',
        transmitterCountry: '',
        transmitterProvince: '',
        transpCigle: '',
        transpName: '',
        vin: '',
        year: '',
        taxes: ''
      },
      datalist: {
        pickup: '',
        pickupUid: '',
        delivery: '',
        deliveryUid: '',
        billing: '',
        billingUid: ''
      },
      previewImgUrl: '',
      previewName: '',
      previewComment: '',
      previewId: '',
      note: {
        name: '',
        text: '',
        date: ''
      },
      reversedNotes: [],
      notes: [],
      paginate: ['reversedNotes'],
      liste: [],
      carriers: [],
      addressbook: []
    }
  },
  methods: {
    sortAsc (list) {
      return list.sort((a, b) => {
        var A = a['.value'].toUpperCase()
        var B = b['.value'].toUpperCase()
        if (A < B) { return -1 }
        if (A > B) { return 1 }
        return 0
      })
    },
    setAndSearch: function (event, section) {
      if (section === 'pickup') {
        this.datalist.pickup = event.value
        this.datalist.pickupUid = event.key
        if (event.key !== null) {
          db.ref('users/dealersList/' + this.datalist.pickupUid).once('value').then((snap) => {
            if (snap.val()) {
              this.order.transmitterName = snap.val().name
              this.order.transmitterAddress = snap.val().address
              this.order.transmitterCity = snap.val().city
              this.order.transmitterPostcode = snap.val().postcode
              this.order.transmitterPhone = snap.val().phone
              this.order.transmitterEmail = snap.val().receptionEmail || ''
              this.order.transmitterFax = snap.val().fax
              this.order.transmitterProvince = snap.val().province
              this.order.transmitterCountry = snap.val().country
            }
          }).catch(function (error) {
            console.log(error)
          })
          this.addressbook.forEach((entry) => {
            if (entry['key'] === this.datalist.pickupUid) {
              this.order.transmitterName = entry.name
              this.order.transmitterAddress = entry.address
              this.order.transmitterCity = entry.city
              this.order.transmitterPostcode = entry.postcode
              this.order.transmitterPhone = entry.phone
              this.order.transmitterEmail = entry.receptionEmail || ''
              this.order.transmitterFax = entry.fax
              this.order.transmitterProvince = entry.province
              this.order.transmitterCountry = entry.country
            }
          })
        }
      }
      if (section === 'delivery') {
        this.datalist.delivery = event.value
        this.datalist.deliveryUid = event.key
        if (event.key !== null) {
          db.ref('users/dealersList/' + this.datalist.deliveryUid).once('value').then((snap) => {
            if (snap.val()) {
              this.order.receiverName = snap.val().name
              this.order.receiverAddress = snap.val().address
              this.order.receiverCity = snap.val().city
              this.order.receiverPostcode = snap.val().postcode
              this.order.receiverPhone = snap.val().phone
              this.order.receiverEmail = snap.val().receptionEmail || ''
              this.order.receiverFax = snap.val().fax
              this.order.receiverProvince = snap.val().province
              this.order.receiverCountry = snap.val().country
            }
          }).catch(function (error) {
            console.log(error)
          })
          this.addressbook.forEach((entry) => {
            if (entry['key'] === this.datalist.deliveryUid) {
              this.order.receiverName = entry.name
              this.order.receiverAddress = entry.address
              this.order.receiverCity = entry.city
              this.order.receiverPostcode = entry.postcode
              this.order.receiverPhone = entry.phone
              this.order.receiverEmail = entry.receptionEmail || ''
              this.order.receiverFax = entry.fax
              this.order.receiverProvince = entry.province
              this.order.receiverCountry = entry.country
            }
          })
        }
      }
      if (section === 'billing') {
        this.datalist.billing = event.value
        this.datalist.billingUid = event.key
        if (event.key !== null) {
          db.ref('users/dealersList/' + this.datalist.billingUid).once('value').then((snap) => {
            if (snap.val()) {
              this.order.payerName = snap.val().name
              this.order.payerAddress = snap.val().address
              this.order.payerCity = snap.val().city
              this.order.payerPostcode = snap.val().postcode
              this.order.payerPhone = snap.val().phone
              this.order.payerEmail = snap.val().receptionEmail || ''
              this.order.payerFax = snap.val().fax
              this.order.payerProvince = snap.val().province
              this.order.payerCountry = snap.val().country
              this.order.sageID = snap.val().sageID
            }
          }).catch(function (error) {
            console.log(error)
          })
          this.addressbook.forEach((entry) => {
            if (entry['key'] === this.datalist.billingUid) {
              // console.log(entry)
              this.order.payerName = entry.name
              this.order.payerAddress = entry.address
              this.order.payerCity = entry.city
              this.order.payerPostcode = entry.postcode
              this.order.payerPhone = entry.phone
              this.order.payerEmail = entry.receptionEmail || ''
              this.order.payerFax = entry.fax
              this.order.payerProvince = entry.province
              this.order.payerCountry = entry.country
              this.order.sageID = entry.sageID
            }
          })
        }
      }
    },
    generate () {
      var id = this.companyUID
      window.axios.get('https://dev.transport.keepneye.com/infobemaster/decode/bol/create/' + id + '/' + this.$route.query.orderId + '/' + this.inspectionOrder.key).then((response) => {
        window.open(response.data.url)
      }).catch((error) => console.log(error))
    },
    sendBolTo () {
      var id = this.companyUID
      window.axios.get('https://dev.transport.keepneye.com/infobemaster/decode/bol/send/' + id + '/' + this.$route.query.orderId + '/' + this.inspectionOrder.key + '/' + this.inspectionOrder.email).then((response) => {
        this.close()
      }).catch((error) => console.log(error))
    },
    mergeBody () {
      this.history.forEach((h) => {
        if (!h.body) {
          db.ref('database/transporter/' + this.companyUID + '/history/' + this.$route.query.orderId).child(h['.key']).update({body: this.findLastBody.body, bol: null})
        }
      })
      this.close()
    },
    validateEmail (email) {
      if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email)) return true
      else return false
    },
    close () {
      this.chat = false
      this.modify = false
      this.modifyDelivery = false
      this.dispatch = false
      this.send = false
      this.inspection = false
      this.preview = false
      if (!this.originalOrder.sageID) this.order.sageID = ''
      for (let attr in this.order) {
        this.order[attr] = ''
      }
      for (let attr in this.originalOrder) {
        this.order[attr] = this.originalOrder[attr]
      }
      for (let attr in this.datalist) {
        this.datalist[attr] = ''
      }
    },
    getDate: function (timestamp) {
      var date = new Date(timestamp)
      return date.toLocaleDateString() + ' ' + date.toLocaleTimeString()
    },
    formatDate (date) {
      var fdate = new Date(date)
      return fdate.getFullYear() + '-' + ('0' + (fdate.getMonth() + 1)).slice(-2) + '-' + ('0' + fdate.getUTCDate()).slice(-2)
    },
    openPreview (url, name, comment, key) {
      this.previewImgUrl = url
      this.preview = true
      key ? this.previewId = key : this.previewId = ''
      name ? this.previewName = name : this.previewName = ''
      comment ? this.previewComment = comment : this.previewComment = ''
    },
    openSend () {
      this.initializeAddressbook()
      this.send = true
      this.order.price = ''
      this.order.numRef = ''
      this.order.comment = ''
      this.carrier = ''
      this.sendOrder.carrier = ''
    },
    initializeAddressbook () {
      var id = this.companyUID
      if (this.addressbook.length === 0) {
        db.ref('database/transporter/' + id + '/carnet').once('value').then((snap) => {
          let addressbookArray = []
          snap.forEach((element) => {
            let item = element.val()
            item.key = element.key
            addressbookArray.push(item)
          })
          this.addressbook = addressbookArray
        })
      }
    },
    openInspection () {
      this.inspection = true
      this.inspectionOrder.key = ''
      this.inspectionOrder.email = ''
    },
    openDispatch () {
      this.initializeAddressbook()
      this.dispatch = true
      this.order.price = ''
      this.order.numRef = ''
      this.order.comment = 'Client/Customer: ' + this.order.payerName
      if (this.userInfo.driverComment) this.order.comment += '\n' + this.originalOrder.comment
      this.dispatchOrder.chauffeur = ''
      this.dispatchOrder.chauffeurName = ''
    },
    openModification () {
      this.initializeAddressbook()
      this.modify = true
      this.order.price = this.originalOrder.price
      this.order.numRef = this.originalOrder.numRef
      this.order.comment = this.originalOrder.comment
    },
    openModificationDelivery (entry) {
      this.modifyDelivery = true
      this.deliveryOrder = entry['.key']
      this.deliveryInvoice = entry.invoice
      this.deliveryChauffeur = entry.chauffeur
      this.order.numRef = entry.numRef
      this.order.price = entry.prix
      this.order.comment = entry.comment
    },
    modifyOrder () {
      var id = this.companyUID
      if (this.order['.key']) delete this.order['.key']
      if (this.order.sageID === undefined) this.order.sageID = ''
      this.order.taxes = this.taxes
      this.order.taxesComment = this.taxesComment
      db.ref('database/transporter/' + id + '/deliveries/' + this.$route.query.orderId).update(this.order).then(() => {
        // ======================== ADD MODIFY ORDER LOG =======================
        this.$store.dispatch('newLog', {'UID': this.uid, 'orderID': this.$route.query.orderId, 'action': 'MODIFY_ORDER', 'date': Date.now()})
        // ======================== ADD MODIFY ORDER LOG =======================
      })
      db.ref('bdcQueue/' + id).child(this.$route.query.orderId).set(this.randomPdfString(12))
      this.close()
    },
    modifyDeliveryAction () {
      var id = this.companyUID
      db.ref('database/transporter/' + id + '/history/' + this.$route.query.orderId + '/' + this.deliveryOrder).update({numRef: this.order.numRef, prix: this.order.price, comment: this.order.comment}).then(() => {
        // ======================== ADD MODIFY HISTORY LOG =======================
        this.$store.dispatch('newLog', {'UID': this.uid, 'orderID': this.$route.query.orderId, 'numRef': this.order.numRef, 'action': 'MODIFY_ORDER_HISTORY', 'date': Date.now()})
        // ======================== ADD MODIFY HISTORY LOG =======================
      })
      this.close()
    },
    dispatchAction () {
      this.liste.forEach((element) => {
        if (element['.key'] === this.dispatchOrder.chauffeur) this.dispatchOrder.chauffeurName = element['.value']
      })
      var dispatchOrder = {
        chauffeur: this.dispatchOrder.chauffeur,
        chauffeurName: this.dispatchOrder.chauffeurName,
        nbDispatch: this.originalOrder.nbDispatch,
        comment: this.order.comment,
        numRef: this.order.numRef,
        prix: this.order.price,
        receiver: this.order.receiverName,
        receiverAddress: this.order.receiverAddress,
        receiverCity: this.order.receiverCity,
        receiverContact: this.order.receiverContact,
        receiverFax: this.order.receiverFax || '',
        receiverName: this.order.receiverName,
        receiverPhone: this.order.receiverPhone,
        receiverEmail: this.order.receiverEmail || '',
        receiverPostcode: this.order.receiverPostcode,
        receiverProvince: this.order.receiverProvince,
        receiverCountry: this.order.receiverCountry,
        transmitter: this.order.transmitterName,
        transmitterAddress: this.order.transmitterAddress,
        transmitterCity: this.order.transmitterCity,
        transmitterContact: this.order.transmitterContact,
        transmitterFax: this.order.transmitterFax || '',
        transmitterName: this.order.transmitterName,
        transmitterPhone: this.order.transmitterPhone,
        transmitterEmail: this.order.transmitterEmail || '',
        transmitterPostcode: this.order.transmitterPostcode,
        transmitterProvince: this.order.transmitterProvince,
        transmitterCountry: this.order.transmitterCountry,
        body: this.findLastBody.body || null,
        dateDispatch: this.getDate(Date.now())
      }
      var id = this.companyUID
      db.ref('test/transporter/' + id + '/newDispatch/' + this.$route.query.orderId).push().set(dispatchOrder).then(() => {
        // ======================== ADD DISPATCH LOG =======================
        this.$store.dispatch('newLog', {'UID': this.uid, 'orderID': this.$route.query.orderId, 'action': 'DISPATCH_ORDER', 'date': Date.now(), 'targetName': this.dispatchOrder.chauffeurName})
        // ======================== ADD DISPATCH LOG =======================
      })
      this.close()
    },
    sendAction () {
      var o = this.order
      var orderID = this.$route.query.orderId
      var id = this.companyUID
      this.carriers.forEach((element) => {
        if (element['.key'] === this.sendOrder.carrier) this.sendOrder.carrierName = element['.value']
      })
      o.transferedFrom = id
      o.idFrom = orderID
      delete o.codeSecret
      delete o.invoice
      delete o['.key']
      delete o.refTransfered
      delete o.priceTransfered
      delete o.isTransfered
      delete o.idTransfer
      o.creationDate = Date.now()
      o.nbDispatch = 0
      o.source = this.userInfo.name
      o.payerName = this.userInfo.name
      o.payerAddress = this.userInfo.address
      o.payerCity = this.userInfo.city
      o.payerPostcode = this.userInfo.postcode
      o.payerProvince = this.userInfo.province
      o.payerEmail = this.userInfo.email
      o.payerPhone = this.userInfo.phone
      o.payerFax = this.userInfo.fax
      o.payerContact = ''
      o.payerCountry = ''
      o.payer = id
      o.sageID = this.userInfo.sageID || ''
      o.cigleOfTransp = o.transpCigle
      o.receiverPhone = o.receiverPhone + ''
      o.receiverFax = o.receiverFax + ''
      o.transmitterPhone = o.transmitterPhone + ''
      o.transmitterFax = o.transmitterFax + ''
      db.ref('database/transporter/' + this.sendOrder.carrier + '/unprocessed/').push().set(o)
      db.ref('database/transporter/' + id + '/deliveries/' + orderID).update({'priceTransfered': o.price, 'status': 'Transférée', 'nameTransfered': this.sendOrder.carrierName, 'isTransfered': this.sendOrder.carrier}).then(() => {
        // ======================== ADD SEND TO CARRIER LOG =======================
        this.$store.dispatch('newLog', {'UID': this.uid, 'orderID': this.$route.query.orderId, 'action': 'SEND_TO_CARRIER', 'date': Date.now(), 'targetName': this.sendOrder.carrierName})
        // ======================== ADD SEND TO CARRIER LOG =======================
      })
      this.close()
    },
    sendNote () {
      this.note.date = Date.now()
      var id = this.companyUID
      db.ref('database/transporter/' + id + '/deliveries/' + this.$route.query.orderId + '/notes/').push().set(this.note).then(() => {
        db.ref('database/transporter/' + id + '/deliveries/' + this.$route.query.orderId).update({readDealer: false})
        for (var attr in this.note) {
          this.note[attr] = ''
        }
      }).catch(function (error) {
        console.log(error)
      })
    },
    changeStatus (status) {
      var id = this.companyUID
      db.ref('database/transporter/' + id + '/deliveries/' + this.$route.query.orderId).child('status').set(status).then(() => {
        // ======================== ADD CHANGE STATUS LOG =======================
        this.$store.dispatch('newLog', {'UID': this.uid, 'orderID': this.$route.query.orderId, 'action': 'CHANGE_ORDER_STATUS', 'status': status, 'date': Date.now()})
        // ======================== ADD CHANGE STATUS LOG =======================
      })
      if (status !== 'Transférée') db.ref('test/transporter/' + id + '/pendingTransfer/' + this.$route.query.orderId).set(null)
    },
    randomPdfString (length) {
      var text = ''
      var possible = 'abcdefghijklmnopqrstuvwxyz0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ'
      for (var i = 0; i < length; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length))
      }
      return text + '.pdf'
    },
    modifyTransferAction () {
      var id = this.companyUID
      db.ref('database/transporter/' + id + '/deliveries/' + this.$route.query.orderId).update(this.modifyTransfer).then(() => {
        // ======================== ADD MODIFY TRANSFER LOG =======================
        this.$store.dispatch('newLog', {'UID': this.uid, 'orderID': this.$route.query.orderId, 'action': 'MODIFY_TRANSFER', 'date': Date.now()})
        // ======================== ADD MODIFY TRANSFER LOG =======================
        this.modifyTransfer.refTransfered = ''
        this.modifyTransfer.priceTransfered = ''
      })
    },
    resend () {
      var id = this.companyUID
      db.ref('database').child('transporter').child(id).child('user').child('employees').child(this.deliveryChauffeur).child('infos').child('email').once('value').then((snap) => {
        db.ref('dispatchToSend').child(id).child(this.$route.query.orderId).child(this.deliveryOrder).set(snap.val())
        this.close()
      })
    },
    regenerate () {
      var id = this.companyUID
      db.ref('dispatchQueue').child(id).child(this.$route.query.orderId).child(this.deliveryOrder).set(this.randomPdfString(12))
      this.close()
    },
    openNote () {
      var id = this.companyUID
      db.ref('database/transporter/' + id + '/deliveries/' + this.$route.query.orderId).update({readTrans: true})
      this.chat = true
    }
  },
  computed: {
    listOrdered () {
      let sortedArray = this.liste.concat()
      return this.sortAsc(sortedArray)
    },
    carriersOrdered () {
      let sortedArray = this.carriers.concat()
      return this.sortAsc(sortedArray)
    },
    noteFilled () {
      return (this.note.text !== '' && this.note.name !== '')
    },
    dispatchFormFilled () {
      var o = this.order
      return (
        this.dispatchOrder.chauffeur !== '' &&
        o.transmitterName !== '' &&
        o.transmitterAddress !== '' &&
        o.transmitterCountry !== '' &&
        o.transmitterCity !== '' &&
        o.transmitterPostcode !== '' &&
        o.transmitterProvince !== '' &&
        o.receiverName !== '' &&
        o.receiverAddress !== '' &&
        o.receiverCountry !== '' &&
        o.receiverCity !== '' &&
        o.receiverPostcode !== '' &&
        o.receiverProvince !== '')
    },
    sendFormFilled () {
      var o = this.order
      return (
        this.sendOrder.carrier !== '' &&
        o.transmitterName !== '' &&
        o.transmitterAddress !== '' &&
        o.transmitterCountry !== '' &&
        o.transmitterCity !== '' &&
        o.transmitterPostcode !== '' &&
        o.transmitterProvince !== '' &&
        o.receiverName !== '' &&
        o.receiverAddress !== '' &&
        o.receiverCountry !== '' &&
        o.receiverCity !== '' &&
        o.receiverPostcode !== '' &&
        o.receiverProvince !== '')
    },
    orderChosen () {
      return (this.inspectionOrder.key !== '')
    },
    emailEntered () {
      return (this.inspectionOrder.email !== '' && this.validateEmail(this.inspectionOrder.email) && this.inspectionOrder.key !== '')
    },
    formCompleted () {
      var o = this.order
      return (
        o.receiverName !== '' &&
        o.receiverAddress !== '' &&
        o.receiverCountry !== '' &&
        o.receiverCity !== '' &&
        o.receiverPostcode !== '' &&
        o.receiverProvince !== '' &&
        o.payerName !== '' &&
        o.payerAddress !== '' &&
        o.payerCountry !== '' &&
        o.payerCity !== '' &&
        o.payerPostcode !== '' &&
        o.payerProvince !== '' &&
        o.transmitterName !== '' &&
        o.transmitterAddress !== '' &&
        o.transmitterCountry !== '' &&
        o.transmitterCity !== '' &&
        o.transmitterPostcode !== '' &&
        o.transmitterProvince !== '' &&
        ((this.isSageOne && o.price !== '') || !this.isSageOne))
    },
    isSageOne () {
      return this.userInfo.isSageOne
    },
    companyUID () {
      return this.$store.state.authorization.company
    },
    uid () {
      return this.$store.state.user.uid
    },
    userInfo () {
      return this.$store.state.userInfo
    },
    findLastBody () {
      let lastBody = {}
      this.history.forEach((h, index) => {
        if (h.body) lastBody = {index: index, body: h.body}
      })
      return lastBody
    }
  },
  created () {
    var id = this.companyUID
    if (this.$route.query.archive) {
      this.$bindAsObject('originalOrder', dbArchives.ref('database/transporter/e58ff614-8449-4c3e-90b8-b42a48c2972b/deliveries').child(this.$route.query.orderId))
    } else {
      this.$bindAsObject('originalOrder', db.ref('database/transporter/' + id + '/deliveries/' + this.$route.query.orderId), null, (snap) => {
        this.order = snap.val()
        var o = this.order
        if (o.transmitterProvince === undefined) this.$set(this.order, 'transmitterProvince', '')
        if (o.transmitterCountry === undefined) this.$set(this.order, 'transmitterCountry', '')
        if (o.receiverProvince === undefined) this.$set(this.order, 'receiverProvince', '')
        if (o.receiverCountry === undefined) this.$set(this.order, 'receiverCountry', '')
        if (o.payerProvince === undefined) this.$set(this.order, 'payerProvince', '')
        if (o.payerCountry === undefined) this.$set(this.order, 'payerCountry', '')
        if (o.billingDate === undefined) this.$set(this.order, 'billingDate', this.formatDate(Date.now()))
        if (snap.val().idTransfer && snap.val().isTransfered) this.$bindAsObject('transfer', db.ref('database/transporter/' + snap.val().isTransfered + '/deliveries/').child(snap.val().idTransfer))
      })
    }
    this.$bindAsArray('history', db.ref('database/transporter/' + id + '/history/' + this.$route.query.orderId))
    this.$bindAsArray('carriers', db.ref('users/transporters/' + id + '/liste'))
    this.$bindAsArray('liste', db.ref('database/transporter/' + id + '/liste'))
    this.$bindAsArray('notes', db.ref('database/transporter/' + id + '/deliveries/' + this.$route.query.orderId + '/notes/'))
    document.getElementById('app').scrollIntoView()
  },
  watch: {
    notes: function (snapshot) {
      if (snapshot) {
        this.reversedNotes = JSON.parse(JSON.stringify(snapshot))
        this.reversedNotes.reverse()
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.table thead th{
  border-bottom: 1px solid #eceeef;
  border-top: none;
}
input, button{
  cursor: pointer;
}
#location{
  height: 300px;
  overflow: hidden;
}
#chat{
  position: relative;
}
#info{
  display: flex;
}
img.mini{
  max-height: 125px;
  max-width: 165px;
  cursor: pointer;
}
img {
  image-orientation: from-image;
}
@media (max-width: 991px){
  #info{
    display: block;
  }
}
.info{
  border-bottom: 1px solid #eceeef;
  overflow-y: auto;
}
.kne-tab.active{
  color: #f7941e !important;
}
.kne-tab:hover{
  color: #f7941e !important;
}
</style>



// WEBPACK FOOTER //
// OrderInfo.vue?78ba804a